// extracted by mini-css-extract-plugin
export default {"message":"Message_message__cTWNa","success":"Message_success__YdRM7","error":"Message_error__gRq7E"};